export const amplitudeDev = 'd0baaa67671a694012f8148ca07a6b8c'
export const amplitudeProd = '6e3c59bf5fba9aad8e18636004359b65'
